'use client';

import React from 'react';
import dynamic from 'next/dynamic';

// Dynamic imports with ssr: false are allowed in Client Components
const RecentlyUsed = dynamic(() => import('@/components/tools/RecentlyUsed'), { ssr: false });
const HomeToolList = dynamic(() => import('@/components/layout/HomeToolList'), { ssr: false });
const TrustedBy = dynamic(() => import('@/components/layout/TrustedBy'), { ssr: false });
const SoftwareServices = dynamic(() => import('@/components/layout/SoftwareServices'), { ssr: false });
const SEOIndex = dynamic(() => import('@/components/layout/SEOIndex'), { ssr: true });
const HomeSEOContent = dynamic(() => import('@/components/layout/HomeSEOContent'), { ssr: true });
const HowItWorks = dynamic(() => import('@/components/layout/HowItWorks'), { ssr: false });
const UseCases = dynamic(() => import('@/components/layout/UseCases'), { ssr: false });
const Testimonials = dynamic(() => import('@/components/layout/Testimonials'), { ssr: false });

export default function HomePageClient() {
  return (
    <>
      <RecentlyUsed />
      <HomeToolList />
      
      <div className="container">
        <UseCases />
      </div>
      
      {/* Trusted By Section */}
      <div style={{ background: 'transparent', borderTop: '1px solid var(--border)', padding: '1.5rem 0 0.5rem', marginTop: '1rem' }}>
        <div className="container">
          <TrustedBy />
          <Testimonials />
        </div>
      </div>

      {/* Software Services Section */}
      <div style={{ background: 'transparent', borderTop: '1px solid var(--border)', padding: '2.5rem 0' }}>
        <div className="container"><SoftwareServices /></div>
      </div>

      <div className="container">
        <HomeSEOContent />
      </div>

      {/* SEO Index & How it Works Section */}
      <div style={{ background: 'transparent', borderTop: '1px solid var(--border)', padding: '0.5rem 0 2rem' }}>
        <div className="container">
          <SEOIndex />
          <HowItWorks />
        </div>
      </div>
    </>
  );
}
